module.exports = __webpack_public_path__ + "img/alert.5ee4ca9f.svg";